enum TransactionStatus {
    CREATED = "CREATED",
    SUCCESS = "SUCCESS",
    FAILURE = "FAILURE"
}

export default TransactionStatus;